import React from 'react'

import { ColumnProps } from 'antd/lib/table'

import { ReimbursementHistoryItem } from 'core/application/adminDashboard/reimbursements/reimbursementsHistory/getReimbursementsHistory'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { Button, Dropdown, Menu, MenuItem } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

export const reimbursementsHistoryColumns = (
  translate: (key: string) => string,
  filter: OrderedPageFilter,
  handleModal: (user: ReimbursementHistoryItem) => void,
  hasESPR = false,
): ColumnProps<ReimbursementHistoryItem>[] => {
  const menu = (record: ReimbursementHistoryItem): JSX.Element => {
    return (
      <Menu>
        <MenuItem key={1}>
          <Button type="text" onClick={() => handleModal(record)}>
            {translate('general.edit')}
          </Button>
        </MenuItem>
      </Menu>
    )
  }

  const taxColumns: ColumnProps<ReimbursementHistoryItem>[] = hasESPR
    ? [
        {
          title: translate('admin-dashboard.reimbursements.reimbursements-history.taxed-label'),
          dataIndex: 'taxable',
          key: 'taxable',
          align: 'right',
          render: (item: number) => {
            return formatMoney(item)
          },
        },
        {
          title: translate('admin-dashboard.reimbursements.reimbursements-history.non-taxed-label'),
          dataIndex: 'nonTaxed',
          key: 'nonTaxed',
          align: 'right',
          render: (item: number) => {
            return formatMoney(item)
          },
        },
      ]
    : []

  const columns: ColumnProps<ReimbursementHistoryItem>[] = [
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-history.full-name-label'),
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'left',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-reimbursement-history-full-name',
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-history.scheduled-date-label'),
      dataIndex: 'scheduleDate',
      key: 'scheduleDate',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (item: string) => {
        return parseZoneFormat(item)
      },
      className: 't-reimbursement-history-schedule-date',
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-history.amount-label'),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-reimbursement-history-amount',
    },
    ...taxColumns,
    {
      title: translate('admin-dashboard.manage-people.employee.action'),
      key: 'action',
      align: 'right',
      render: (text: string, record: ReimbursementHistoryItem) => (
        <>
          <Dropdown overlay={menu(record)}>
            <Button>...</Button>
          </Dropdown>
        </>
      ),
    },
  ]

  const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
  columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

  return columns
}
